const DEFAULT_ALLOWED_NAMES = ['ITAR', 'ADR', 'Warehouse']

export const getMaterialReceptionColumns = ({
  columns,
  extendedColumns,
  editIndex
}) => {
  if (!extendedColumns || extendedColumns.length === 0 || (editIndex !== null && editIndex >= -1)) {
    return columns
  }
  const filteredExtendedColumns = extendedColumns.filter((col) => DEFAULT_ALLOWED_NAMES.includes(col?.name))
  return columns.concat(filteredExtendedColumns)
}
